<template>
  <!--    //@ ts-ignore-->
  <div class="passengersComponent" v-on:click="toggleModal(true)">
    <img class="passengersImg" v-if="!passengersModal" src="/assets/images/Framepeople-icon.png" alt="user-image">
    <img class="passengersImg" v-if="passengersModal" src="/assets/images/userActive.svg" alt="user-image">
    <div class="passengersContent">
      <h5>{{$t('passengers')}}</h5>
      <p>{{ passengerCount }}</p>
    </div>
    <div v-if="passengersModal">
      <transition name="passengersModal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-content">
              <div class="modal-header" id="passengersModalHeader">
                <button type="button" class="close" v-on:click.stop="closeModal(false)"><span aria-hidden="true">&times;</span></button>
              </div>
              <div class="modal-body">
                <div class="passengersModalText">
                  <h5>{{$t('passengers')}}</h5>
                  <p>{{$t('choose_passenger_count')}}</p>
                </div>
                <div class="passengersModalButtons">
                  <img v-on:click="decreasePassengerCount" src="/assets/images/minus-circle.svg" alt="user-image">
                  {{ passengerCount }}
                  <img v-on:click="increasePassengerCount" src="/assets/images/plus-circle.svg" alt="user-image">
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
  <div v-if="passengersModal" id="closePassengersModal" v-on:click="closeModal(false)"></div>

</template>

<script lang="ts">
import {defineComponent} from 'vue';
import './Passengers.scss';

export default defineComponent({
  name: 'PassengersComponent',
  emits: ['getPassengers'],
  props: {
    passengersStore: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      passengerCount: 1,
      passengersModal: false
    }
  },
  methods: {
    toggleModal: function (value) {
      this.passengersModal = value;
    },
    closeModal: function (value) {
      this.passengersModal = value;
    },
    increasePassengerCount: function () {
      this.passengerCount++;
      let payload = this.passengerCount;
      this.$emit('getPassengers', payload)

    },
    decreasePassengerCount: function () {
      if (this.passengerCount > 1) {
        this.passengerCount--;
        let payload = this.passengerCount;
        this.$emit('getPassengers', payload)
      }
    },
    sendData() {
      this.$emit('getPassengers', this.passengerCount)
    },
  },

  created() {
    if(this.passengersStore > 1) {
      this.passengerCount = this.passengersStore;
    } else {
      this.sendData();
    }

  }
});

</script>